import { parse } from "tldts";

export const getUrlData = () => {
  const subdomain = parse(window.location.origin).subdomain;
  let url = "";
  let appType = "";
  let merchantCode = "";
  let payItemCode = "";

  switch (subdomain) {
    case "moekaduna":
      appType = "codsm";
      url = "https://moekaduna.kssqaa.org/vn";
      break;
    case "v5":
      appType = "codsmi";
      url = "https://v5.kssqaa.org/vn";
      break;
    case "kadunasm":
      appType = "codsmi";
      url = "https://v4.kssqaa.org/vn";
      break;

    default:
      appType = "codsmi";
      merchantCode = "ss";
      payItemCode = "ss";
      // url =  "https://wqpqo.basmeemis.org/vn"
      // url = "https://v5.kssqaa.org/vn";
      url = "https://v5.kssqaa.org/vn";
    // url = "https://moekaduna.kssqaa.org/vn";
  }
  return { url, subdomain, appType, merchantCode, payItemCode };
};
